export const DEFAULT_DIAL_CODE = '52';

export const DIAL_CODES = [
  { code: '52', country: 'MX', nationalLength: 10 },
  { code: '1', country: 'US', nationalLength: 10 },
  { code: '57', country: 'CO', nationalLength: 10 },
  { code: '54', country: 'AR', nationalLength: 10 },
  { code: '56', country: 'CL', nationalLength: 9 },
  { code: '51', country: 'PE', nationalLength: 9 },
  { code: '593', country: 'EC', nationalLength: 9 },
  { code: '502', country: 'GT', nationalLength: 8 },
] as const;

export type DialCode = (typeof DIAL_CODES)[number]['code'];

export function nationalLengthForDial(dialCode: string): number {
  const found = DIAL_CODES.find((item) => item.code === dialCode);
  return found?.nationalLength ?? 12;
}

export function formatE164(dialCode: string, national: string): string {
  return `+${dialCode.replace(/\D/g, '')}${national.replace(/\D/g, '')}`;
}

export function isValidNationalPhone(dialCode: string, national: string): boolean {
  const digits = national.replace(/\D/g, '');
  const expected = nationalLengthForDial(dialCode);
  if (dialCode === DEFAULT_DIAL_CODE || dialCode === '1') {
    return digits.length === expected;
  }
  return digits.length >= 8 && digits.length <= expected;
}

const DIAL_CODES_LONGEST_FIRST = [...DIAL_CODES]
  .map((item) => item.code)
  .sort((a, b) => b.length - a.length);

/** Split stored E.164 / leftover UUC_ / bare MX digits into picker parts. */
export function splitStoredPhone(stored: string | null | undefined): {
  dialCode: string;
  national: string;
} {
  if (!stored?.trim()) return { dialCode: DEFAULT_DIAL_CODE, national: '' };
  const uuc = stored.trim().match(/^UUC_(\d+)_/i);
  const digits = (uuc ? uuc[1] : stored).replace(/\D/g, '');
  const dial = DIAL_CODES_LONGEST_FIRST.find(
    (code) => digits.startsWith(code) && digits.length > code.length
  );
  if (dial) return { dialCode: dial, national: digits.slice(dial.length) };
  return { dialCode: DEFAULT_DIAL_CODE, national: digits };
}
